import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://marge-auto.com';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const DEFAULTS = {
    title: 'Marge Auto — Calculateur de marge automobile',
    description: 'Calculez la rentabilité réelle de chaque véhicule d\'occasion. TVA sur marge, frais, commissions. Logiciel SaaS pour professionnels automobile. Essai gratuit 30 jours.',
    image: DEFAULT_IMAGE,
    type: 'website',
};

export default function SEOHead({
    title,
    description,
    path = '',
    image,
    type,
    noindex = false,
    schema,
}) {
    const pageTitle = title || DEFAULTS.title;
    const pageDesc = description || DEFAULTS.description;
    const pageUrl = `${SITE_URL}${path}`;
    const pageImage = image || DEFAULTS.image;
    const pageType = type || DEFAULTS.type;

    return (
        <Helmet>
            <title>{pageTitle}</title>
            <meta name="description" content={pageDesc} />
            <link rel="canonical" href={pageUrl} />

            {noindex && <meta name="robots" content="noindex, nofollow" />}

            {/* Open Graph */}
            <meta property="og:title" content={pageTitle} />
            <meta property="og:description" content={pageDesc} />
            <meta property="og:url" content={pageUrl} />
            <meta property="og:image" content={pageImage} />
            <meta property="og:type" content={pageType} />
            <meta property="og:site_name" content="Marge Auto" />
            <meta property="og:locale" content="fr_FR" />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={pageTitle} />
            <meta name="twitter:description" content={pageDesc} />
            <meta name="twitter:image" content={pageImage} />

            {/* Schema.org JSON-LD */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
}
